import { cloneSystemData } from './system_data_contract.mjs';

const MAX_ROWS = 10000, MAX_MEMBERS = 100000;
const text = (value, fallback = '') => typeof value === 'string' ? value : fallback;
function identifier(value) {
  if (typeof value !== 'string' || !value || value.trim() !== value || value.length > 256) throw new TypeError('Ungültige Listenkennung.');
  return value;
}
function owned(owner, value) {
  for (const key of ['owner', 'systemId', 'systemKey', 'systemType']) {
    if (value[key] !== undefined && value[key] !== owner) throw new TypeError('Fremder Listenbesitzer.');
  }
}
function booleanField(value, key) {
  if (value[key] !== undefined && typeof value[key] !== 'boolean') throw new TypeError('Ungültiger Listenstatus.');
}
function thenMethod(value) {
  let current = value;
  for (let depth = 0; current && typeof current === 'object' && depth < 64; depth++, current = Object.getPrototypeOf(current)) {
    const descriptor = Object.getOwnPropertyDescriptor(current, 'then');
    if (!descriptor) continue;
    if (!Object.hasOwn(descriptor, 'value')) throw new TypeError('Listenzugriffe dürfen keine Getter enthalten.');
    return typeof descriptor.value === 'function';
  }
  return false;
}
function rows(value) {
  if (thenMethod(value)) {
    Promise.resolve(value).catch(() => undefined);
    throw new TypeError('Listen müssen synchron gelesen werden.');
  }
  const data = cloneSystemData(value);
  if (!Array.isArray(data) || data.length > MAX_ROWS) throw new TypeError('Ungültige Objektliste.');
  return data;
}
function freeze(value) {
  if (value && typeof value === 'object') { Object.values(value).forEach(freeze); Object.freeze(value); }
  return value;
}

/** Public native object shape, detached from any legacy raw/project payload. */
export function normalizeNativeCoreObjects(owner, value) {
  const seen = new Set();
  return freeze(rows(value).map(object => {
    if (!object || typeof object !== 'object' || Array.isArray(object)) throw new TypeError('Ungültiges Objekt.');
    owned(owner, object); booleanField(object, 'visible'); booleanField(object, 'active');
    const id = identifier(object.id);
    if (seen.has(id)) throw new TypeError('Doppelte Objektkennung.');
    seen.add(id);
    return { id, objectId: id, systemId: owner, objectType: text(object.objectType, 'object'),
      displayName: text(object.displayName, id), sidebarMeta: text(object.sidebarMeta),
      visible: object.visible !== false, active: object.active === true };
  }));
}

/** Rows project existing owner members; no drawing object or group is created. */
export function normalizeSidebarRows(owner, value) {
  const seen = new Set();
  let memberCount = 0;
  return freeze(rows(value).map(row => {
    if (!row || typeof row !== 'object' || Array.isArray(row)) throw new TypeError('Ungültige Summenzeile.');
    owned(owner, row);
    const id = identifier(row.id);
    if (seen.has(id)) throw new TypeError('Doppelte Zeilenkennung.');
    seen.add(id);
    if (!Array.isArray(row.members) || !row.members.length || (memberCount += row.members.length) > MAX_MEMBERS) {
      throw new TypeError('Summenzeile benötigt begrenzte Mitglieder.');
    }
    const members = row.members.map(member => {
      if (!member || typeof member !== 'object' || Array.isArray(member)) throw new TypeError('Ungültiges Mitglied.');
      owned(owner, member); booleanField(member, 'visible'); booleanField(member, 'selected');
      return { id: identifier(member.id), visible: member.visible !== false, selected: member.selected === true };
    });
    if (new Set(members.map(member => member.id)).size !== members.length) throw new TypeError('Doppelte Mitglieder.');
    const visibleCount = members.filter(member => member.visible).length;
    return { id, systemId: owner, displayName: text(row.displayName, id), sidebarMeta: text(row.sidebarMeta),
      members, memberIds: members.map(member => member.id), count: members.length,
      visibility: visibleCount === 0 ? 'hidden' : visibleCount === members.length ? 'visible' : 'mixed',
      active: members.some(member => member.selected) };
  }));
}
